export const commentsSectionTemplate = '{"blocks":[{"key":"3j2s1","text":"Change Me!","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';
